/**
 * @description invaildate Query Key
 * swagger 기준으로 나누기
 */

export const QUERY_BASE_KEY = {
  TEAMS: "TEAMS",
  NURSES: "NURSES",
  WANTED: "WANTED",
  GROUPS: "GROUPS",
  ISSUED: "ISSUED",
  SNAPSHOT: "SNAPSHOT",
  ROSTER: "ROSTER",
  WEEKLYOFF: "WEEKLYOFF",
  SESSION: "SESSION",
  WANTED_CONFIG: "WANTED_CONFIG",
} as const;

type BaseKeys = keyof typeof QUERY_BASE_KEY;

type QueryKeys = {
  [K in BaseKeys]: { [SK in BaseKeys & { DEFAULT: string }]: string[] };
};

export const QUERY_KEY: QueryKeys = {
  TEAMS: {
    DEFAULT: [QUERY_BASE_KEY.TEAMS],
    LIST: [QUERY_BASE_KEY.TEAMS],
  },
  NURSES: {
    DEFAULT: [QUERY_BASE_KEY.NURSES],
    LIST: [QUERY_BASE_KEY.NURSES],
  },
  WANTED: {
    DEFAULT: [QUERY_BASE_KEY.WANTED],
  },
  GROUPS: {
    DEFAULT: [QUERY_BASE_KEY.GROUPS],
    LIST: [QUERY_BASE_KEY.GROUPS],
  },
  SNAPSHOT: {
    DEFAULT: [QUERY_BASE_KEY.SNAPSHOT],
  },
  ROSTER: {
    DEFAULT: [QUERY_BASE_KEY.ROSTER],
  },
  ISSUED: {
    DEFAULT: [QUERY_BASE_KEY.ISSUED],
  },

  WEEKLYOFF: {
    DEFAULT: [QUERY_BASE_KEY.WEEKLYOFF],
  },
  SESSION: {
    DEFAULT: [QUERY_BASE_KEY.SESSION],
  },
  WANTED_CONFIG: {
    DEFAULT: [QUERY_BASE_KEY.WANTED_CONFIG],
  },
};
